/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ClockInTaskIcon1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Tysiav2ClockInTaskIcon from 'DesignSystem/Svgs/Tysiav2ClockInTaskIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ClockInTaskIcon1({
  children,
  viewPath = "/DesignSystem/TaskBoardIcon/Icon/Tysiav2ClockInTaskIcon",
  height,
  width
  
}) {
let iconColorValueData = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'color',
})
  return (<React.Fragment
>
<Tysiav2ClockInTaskIcon
  viewPath={`${viewPath}/Tysiav2ClockInTaskIcon`}
 data="icon.color"
 fill2={iconColorValueData}
 height={height}
 width={width}
/>
{children}
</React.Fragment>)
}